import { useUserState } from '../../../../../ui/hooks';
import { useContactManagementTranslation } from '../../../../../ui/hooks/useContactManagementTranslation';
import { useFunctionClient } from '@juvare/platform-sdk-react/ui/hooks';
import { Alert, Card, CardContent, CardHeader, LinearProgress, Link, Typography } from '@mui/material';
import React from 'react';
export const PendingMemberships = (props) => {
    const userState = useUserState();
    const { t } = useContactManagementTranslation();
    const [count, setCount] = React.useState();
    const [error, setError] = React.useState();
    const functionClient = useFunctionClient();
    React.useEffect(() => {
        if (userState !== undefined) {
            functionClient
                .executeFunction({
                functionName: 'getOrgMemberCounts',
            })
                .then((response) => response.result)
                .then((result) => {
                const memberCount = result
                    .map((count) => count.memberCount)
                    .reduce((sum, currentValue) => {
                    return sum + currentValue;
                }, 0);
                setCount(memberCount);
            })
                .catch(setError);
        }
    }, [functionClient, userState]);
    const PendingMembershipsCardContent = () => {
        if (error) {
            return React.createElement(Alert, { severity: 'error' }, t('common.errorMessage'));
        }
        if (count === undefined) {
            return React.createElement(LinearProgress, null);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Typography, { sx: { pb: 2 }, "data-test": 'pending-memberships-count', variant: 'body1' }, t('panels.organizations.pendingMember', { count: count })),
            props.onNavigateToOrganizations && (React.createElement(Link, { sx: { mt: 2, cursor: 'pointer' }, onClick: () => props.onNavigateToOrganizations && props.onNavigateToOrganizations(), variant: 'body1', "data-test": 'pending-members-count-link', tabIndex: 0 }, t('panels.organizations.goToManagedOrganizations')))));
    };
    return (React.createElement(Card, { "data-test": 'pending-memberships-card', sx: { width: '100%', height: '100%' } },
        React.createElement(CardHeader, { title: t('panels.organizations.pendingMemberships'), "data-test": 'pending-memberships-card-title' }),
        React.createElement(CardContent, { "data-test": 'pending-memberships-card-content' },
            React.createElement(PendingMembershipsCardContent, null))));
};
